import * as i0 from "@angular/core";
export class BookingFareSelectSyncService {
    constructor() {
        this.isBlueBenefitsSelected = false;
        this.useSamePriorityBoardingOptionForAllPassengers = false;
        this.passengersInitialPriorityBoardingChoice = {};
        this.flights = null;
    }
}
BookingFareSelectSyncService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BookingFareSelectSyncService_Factory() { return new BookingFareSelectSyncService(); }, token: BookingFareSelectSyncService, providedIn: "root" });
